import { render, staticRenderFns } from "./createCompany.vue?vue&type=template&id=56740f74&scoped=true"
import script from "./createCompany.vue?vue&type=script&lang=js"
export * from "./createCompany.vue?vue&type=script&lang=js"
import style0 from "./createCompany.vue?vue&type=style&index=0&id=56740f74&prod&lang=css"
import style1 from "../statistics/css/createCompany.css?vue&type=style&index=1&id=56740f74&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56740f74",
  null
  
)

export default component.exports